import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import { PlanPageActions } from './plan.actions';
import { PupilContextActions } from '@lyceo/shared/pupil-context/data-access';
import { AuthActions } from '@lyceo/shared/auth/data-access';

export const PLAN_FEATURE_KEY: string = 'plan';

export interface PlanState {
  activeDate: Date;
  selectedDate: Date;
  numberOfWeeks: number;
}

export const initialPlanState: PlanState = {
  activeDate: new Date(),
  selectedDate: new Date(),
  numberOfWeeks: 3,
};

const reducer: ActionReducer<PlanState, Action> = createReducer(
  initialPlanState,
  on(AuthActions.logoutSuccess, (): PlanState => initialPlanState),
  on(
    PlanPageActions.activeDateChanged,
    (state, action): PlanState => ({
      ...state,
      activeDate: action.date,
    }),
  ),
  on(
    PlanPageActions.calendarDayClicked,
    PlanPageActions.calendarTaskClicked,
    (state, action): PlanState => ({
      ...state,
      selectedDate: action.date,
    }),
  ),
  on(
    PlanPageActions.todayButtonClicked,
    PlanPageActions.enter,
    (state, _action): PlanState => ({
      ...state,
      selectedDate: new Date(),
      activeDate: new Date(),
    }),
  ),
  on(
    PlanPageActions.numberOfWeeksClicked,
    (state, action): PlanState => ({
      ...state,
      numberOfWeeks: action.numberOfWeeks,
    }),
  ),
  on(
    PupilContextActions.setPupilContext,
    (state): PlanState => ({
      ...state,
      activeDate: new Date(),
      selectedDate: new Date(),
    }),
  ),
);

export function planReducer(
  state: PlanState | undefined,
  action: Action,
): PlanState {
  return reducer(state, action);
}
